(function () {
  const sections = document.querySelectorAll('[data-routed-wearing]');

  sections.forEach((section) => {
    const track = section.querySelector('[data-wearing-track]');
    const prevBtn = section.querySelector('[data-wearing-prev]');
    const nextBtn = section.querySelector('[data-wearing-next]');
    if (!track || !prevBtn || !nextBtn) return;

    const getStep = () => {
      const card = track.querySelector('.routed-wearing__card');
      if (!card) return track.clientWidth * 0.8;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.offsetWidth + gap;
    };

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const hideArrows = maxScroll <= 4;
      prevBtn.style.display = hideArrows ? 'none' : '';
      nextBtn.style.display = hideArrows ? 'none' : '';
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
    };

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    setTimeout(updateButtons, 100);
  });
})();